<template>
  <div class="breadcrumb-container">
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="index==levelList.length-1">{{ item.meta.title }}</span>
        <a v-else @click.prevent="$router.push(item.path)" class="redirect">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: []
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched
      
      // const first = matched[0]
      // if (first && first.path !== 'home') {
      //   matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
      // }

      this.levelList = matched.filter(item => item.meta && item.meta.title)
    },
  }
}
</script>

<style scoped>
  .breadcrumb-container {
    padding: 0 25px;
    box-shadow:0px 2px 8px 0px rgba(196,196,196,0.5);
  }
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 12px;
    line-height: 30px;
  }
  .app-breadcrumb.el-breadcrumb .redirect {
    color: #999;
    cursor: pointer;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/layout/breadcrumb.vue